import React from "react";
import { Link } from "react-router-dom";
import CustomModal from "./Modal";

const DispatchTableCompleted = ({ data }) => {
  return (
    <div className="flex flex-col gap-6">
      {data?.map((item, index) => {
        return (
          <div className="flex flex-col gap-3 bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden" key={index}>
            {/* Header summary tags */}
            <div className="flex flex-wrap gap-3 items-center justify-between bg-slate-50 px-4 py-3 border-b border-slate-200">
              <div className="flex items-center gap-2">
                <span className="bg-amber-100 text-amber-900 border border-amber-300 font-bold px-3 py-1 rounded-lg text-xs shadow-sm flex items-center gap-1.5">
                  <span>📅</span>
                  <span>Date: {item._id}</span>
                </span>
              </div>
              <div className="flex flex-wrap gap-2 items-center">
                {item.tag > 0 && (
                  <span className="bg-blue-50 text-blue-800 border border-blue-200 font-bold px-2.5 py-1 rounded-md text-xs">
                    Tag: {item.tag}
                  </span>
                )}
                {item.stancil > 0 && (
                  <span className="bg-purple-50 text-purple-800 border border-purple-200 font-bold px-2.5 py-1 rounded-md text-xs">
                    Stancil: {item.stancil}
                  </span>
                )}
                {item.trading > 0 && (
                  <span className="bg-emerald-50 text-emerald-800 border border-emerald-200 font-bold px-2.5 py-1 rounded-md text-xs">
                    Trading: {item.trading}
                  </span>
                )}
              </div>
            </div>

            <div className="w-full overflow-x-auto">
              <table className="w-full border-collapse text-left">
                <thead>
                  <tr className="bg-gradient-to-r from-amber-400 via-yellow-400 to-amber-400 text-slate-900 border-b border-amber-500">
                    <th className="px-3 py-2.5 text-left text-xs font-extrabold uppercase tracking-wider border-r border-amber-500 whitespace-nowrap">
                      Date
                    </th>
                    <th className="px-3 py-2.5 text-left text-xs font-extrabold uppercase tracking-wider border-r border-amber-500 whitespace-nowrap">
                      City
                    </th>
                    <th className="px-3 py-2.5 text-left text-xs font-extrabold uppercase tracking-wider border-r border-amber-500 whitespace-nowrap">
                      Location
                    </th>
                    <th className="px-3 py-2.5 text-left text-xs font-extrabold uppercase tracking-wider border-r border-amber-500 whitespace-nowrap">
                      Items
                    </th>
                    <th className="px-3 py-2.5 text-center text-xs font-extrabold uppercase tracking-wider border-r border-amber-500 whitespace-nowrap">
                      Quantity
                    </th>
                    <th className="px-3 py-2.5 text-center text-xs font-extrabold uppercase tracking-wider border-r border-amber-500 whitespace-nowrap">
                      PhoneNumber
                    </th>
                    <th className="px-3 py-2.5 text-left text-xs font-extrabold uppercase tracking-wider border-r border-amber-500 whitespace-nowrap">
                      Customer Name
                    </th>
                    <th className="px-3 py-2.5 text-center text-xs font-extrabold uppercase tracking-wider border-r border-amber-500 whitespace-nowrap">
                      Image
                    </th>
                    <th className="px-3 py-2.5 text-center text-xs font-extrabold uppercase tracking-wider whitespace-nowrap bg-amber-400">
                      <div className="flex items-center justify-center gap-1.5">
                        <span>Action</span>
                        <Link
                          to={`/pdf/admin/complete`}
                          target="_blank"
                          className="bg-red-600 hover:bg-red-700 active:bg-red-800 text-white text-[10px] font-black px-2 py-0.5 rounded shadow transition active:scale-95 inline-flex items-center gap-0.5"
                          title="Open Complete PDF"
                        >
                          <span>📄</span>
                          <span>PDF</span>
                        </Link>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-200">
                  {item?.data?.map((date, index2) => {
                    const orders = date?.orders?.length || 1;
                    return (
                      <React.Fragment key={index2}>
                        {date?.orders?.map((order, index3) => {
                          const isGroupBottom = index3 === orders - 1;
                          return (
                            <tr
                              key={index3}
                              className={`transition-colors hover:bg-slate-50/80 ${
                                isGroupBottom ? "border-b-2 border-slate-300" : "border-b border-slate-100"
                              }`}
                            >
                              {/* Time */}
                              <td className="px-3 py-2 text-xs text-gray-700 border-r border-slate-200 whitespace-nowrap">
                                <div className="font-semibold text-gray-800">
                                  {new Date(order?.updatedAt).toLocaleTimeString("en-US", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  })}
                                </div>
                              </td>

                              {/* City */}
                              <td className="px-3 py-2 text-xs font-semibold text-gray-700 border-r border-slate-200 whitespace-nowrap">
                                {order?.group || "-"}
                              </td>

                              {/* Location */}
                              <td className="px-3 py-2 text-xs text-gray-600 border-r border-slate-200 max-w-[150px] truncate" title={order?.customer?.location}>
                                {order?.customer?.location || "-"}
                              </td>

                              {/* Items */}
                              <td className="px-3 py-2 text-xs font-bold text-gray-900 border-r border-slate-200">
                                {order?.product?.productName || "-"}
                              </td>

                              {/* Quantity */}
                              <td className="px-3 py-2 text-xs font-bold text-center border-r border-slate-200">
                                <span className="bg-blue-50 text-blue-800 px-2 py-0.5 rounded font-mono font-bold">
                                  {order?.quantity}
                                </span>
                              </td>

                              {/* PhoneNumber (Grouped) */}
                              {index3 === 0 && (
                                <td
                                  rowSpan={orders}
                                  className="px-3 py-2 text-xs font-mono font-bold text-gray-800 border-r border-slate-200 text-center whitespace-nowrap align-middle bg-white"
                                >
                                  {date.phoneNumber || "-"}
                                </td>
                              )}

                               {/* Customer Name */}
                               <td className="px-3 py-2 text-xs font-bold text-gray-900 border-r border-slate-200 align-middle">
                                 <div className="font-bold text-slate-900 text-xs">
                                   {order?.customer?.userName || "Customer"}
                                 </div>
                               </td>

                              {/* Image (Grouped) */}
                              {index3 === 0 && (
                                <td
                                  rowSpan={orders}
                                  className="px-3 py-2 whitespace-nowrap border-r border-slate-200 align-middle bg-white text-center"
                                >
                                  <Images images={date?.images} />
                                </td>
                              )}

                              {/* Empty Action cell or Status for completed */}
                              {index3 === 0 && (
                                <td
                                  rowSpan={orders}
                                  className="px-3 py-2 whitespace-nowrap align-middle bg-white text-center"
                                >
                                  <span className="bg-emerald-50 text-emerald-800 border border-emerald-200 px-2.5 py-1 rounded-md text-xs font-bold inline-flex items-center gap-1">
                                    <span>✓</span>
                                    <span>Completed</span>
                                  </span>
                                </td>
                              )}
                            </tr>
                          );
                        })}
                      </React.Fragment>
                    );
                  })}
                  {(!item?.data || item?.data?.length === 0) && (
                    <tr>
                      <td colSpan={9} className="px-4 py-8 text-center text-gray-500 font-semibold bg-gray-50 text-sm">
                        No Data Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        );
      })}
      {(!data || data?.length === 0) && (
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-8 text-center text-gray-500 font-semibold text-sm">
          📦 No Completed Dispatches Found
        </div>
      )}
    </div>
  );
};

export default DispatchTableCompleted;

const Images = ({ images }) => {
  const [open, setOpen] = React.useState(false);
  const count = images?.length || 0;
  return (
    <div>
      {count > 0 ? (
        <button
          onClick={() => setOpen(true)}
          className="bg-emerald-600 hover:bg-emerald-700 text-white px-2.5 py-1 rounded text-xs font-bold shadow-sm transition active:scale-95 cursor-pointer flex items-center justify-center gap-1 mx-auto"
        >
          <span>🖼️</span>
          <span>View ({count})</span>
        </button>
      ) : (
        <span className="text-gray-400 text-xs italic">-</span>
      )}
      <CustomModal open={open} setOpen={setOpen} button={<></>}>
        <div className="grid grid-cols-2 gap-3 p-2">
          {images?.map((item, index) => (
            <a key={index} href={item} target="_blank" rel="noreferrer" className="block border rounded-lg p-1 hover:shadow-lg transition">
              <img
                src={item}
                alt="preview"
                className="h-80 w-full object-contain rounded"
              />
            </a>
          ))}
        </div>
      </CustomModal>
    </div>
  );
};
